import React from 'react';
import { Col } from 'antd';
import { WorkstationFormItem } from '@/components/views/Resolution886/components/Form';

export function Workstation(): JSX.Element {
	return (
		<Col xs={24}>
			<WorkstationFormItem fieldName="workstation_id" required={false} />
		</Col>
	);
}
